export const gtmScript = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });
  var f = document.getElementsByTagName("script")[0];
  var j = document.createElement("script");
  j.async = true;
  j.src =
    "https://www.googletagmanager.com/gtm.js?id=" +
    process.env.REACT_APP_GOOGLE_TAG_MANAGER_CONTAINER_ID +
    "&l=dataLayer";
  if (f && f.parentNode) {
    f.parentNode.insertBefore(j, f);
  }
};

export const kameleoonScripts = () => {
  // Duration in milliseconds to wait while the Kameleoon application file is loaded
  var kameleoonLoadingTimeout = 1000;

  window.kameleoonQueue = window.kameleoonQueue || [];
  window.kameleoonStartLoadTime = new Date().getTime();
  if (
    !document.getElementById("kameleoonLoadingStyleSheet") &&
    !window.kameleoonDisplayPageTimeOut
  ) {
    var kameleoonS = document.getElementsByTagName("script")[0];
    var kameleoonCc = "* { visibility: hidden !important; background-image: none !important; }";
    var kameleoonStn = document.createElement("style");
    kameleoonStn.id = "kameleoonLoadingStyleSheet";
    kameleoonStn.appendChild(document.createTextNode(kameleoonCc));
    if (kameleoonS && kameleoonS.parentNode) {
      kameleoonS.parentNode.insertBefore(kameleoonStn, kameleoonS);
    }
    window.kameleoonDisplayPage = function (fromEngine: boolean) {
      if (!fromEngine) {
        window.kameleoonTimeout = true;
      }
      if (kameleoonStn.parentNode) {
        kameleoonStn.parentNode.removeChild(kameleoonStn);
      }
    };
    window.kameleoonDisplayPageTimeOut = window.setTimeout(
      window.kameleoonDisplayPage,
      kameleoonLoadingTimeout
    );
  }

  var kameleoonIframeURL = "https://" + window.location.hostname + "/kameleoon-iframe.html";

  window.kameleoonLightIframe = false;
  var kameleoonIframeOriginElement = document.createElement("a");
  kameleoonIframeOriginElement.href = kameleoonIframeURL;
  window.kameleoonIframeOrigin =
    kameleoonIframeOriginElement.origin ||
    kameleoonIframeOriginElement.protocol + "//" + kameleoonIframeOriginElement.hostname;
  if (window.location.href.indexOf(window.kameleoonIframeOrigin) !== 0) {
    window.kameleoonLightIframe = true;
    var kameleoonProcessMessageEvent = function (event: MessageEvent) {
      if (
        window.kameleoonIframeOrigin === event.origin &&
        event.data.slice &&
        event.data.slice(0, 9) === "Kameleoon"
      ) {
        window.removeEventListener("message", kameleoonProcessMessageEvent);
        window.kameleoonExternalIFrameLoaded = true;
        if (window.Kameleoon) {
          eval(event.data);
          window.Kameleoon.Analyst.load();
        } else {
          window.kameleoonExternalIFrameLoadedData = event.data;
        }
      }
    };
    if (window.addEventListener) {
      window.addEventListener("message", kameleoonProcessMessageEvent, false);
    }
    var iframeNode = document.createElement("iframe");
    iframeNode.src = kameleoonIframeURL;
    iframeNode.id = "kameleoonExternalIframe";
    iframeNode.style.cssFloat = "left !important";
    iframeNode.style.height = "0px !important";
    iframeNode.style.opacity = "0.0 !important";
    iframeNode.style.width = "0px !important";
    document.head.appendChild(iframeNode);
  }
};
